<div>
  <div *ngIf="isLoading" class="spinner">
    <mat-spinner></mat-spinner>
    Loading Data....
  </div>
  <div *ngIf="brokerIdComplete === false && !isLoading" id="broker-home" class="flex">
    <div class="grid grid-cols-1">
      <div class="flex flex-col">
        <div class="col-start-1 col-end-4 p-8 sm:w-auto md:w-full bg-white">
          <div class="text-lg font-bold">Please Enter Broker Identification</div>
          <div class="flex flex-col pt-2">
            <div class="text-center">
              <form id="brokerId" #brokerIdForm="ngForm" class="flex flex-col pt-8">
                <mat-form-field class="sm:w-full md:w-500px my-3">
                  <mat-label>Broker Id</mat-label>
                  <input matInput name="BrokerId" required id="BrokerId" [(ngModel)]="brokerId" >
              </mat-form-field>
              </form>
            </div>
          </div>
          <div>
            <div class="text-right">
              <button mat-flat-button color="primary" [disabled]="!brokerIdForm.form.valid" (click)="submitBrokerId()" class="h-10 px-6 my-1">SUBMIT</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="brokerIdComplete === true && !isLoading" class="flex flex-col" >
    <div class="flex flex-col justify-center sm:w-auto">
      <div class="mb-8 flex flex-col justify-center sm:w-auto">
        <div class="flex justify-center text-3xl sm:text-40px sm:font-rhetorik-sans mt-6">Generate Referral Link</div>
        <div class="flex justify-center px-0 sm:px-20 text-gray-tricon text-xl sm:text-xl mt-2">Search for a home.</div>
      </div>
    </div>
    <div class="sm:w-auto flex justify-center border-0 w-full">
        <mat-form-field class="md:w-500px w-322px my-2">
          <input type="text"
                placeholder="Address"
                aria-label="Number"
                matInput
                [formControl]="myControl"
                [matAutocomplete]="auto" required>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)='onSelect($event.option.value)'>
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
              {{option}}
            </mat-option>
          </mat-autocomplete>
          <mat-error>
            Please select a home.
          </mat-error>
        </mat-form-field>
    </div>
    <div *ngIf="selectedProperty !== null" class="sm:w-auto flex flex-col justify-center border-0 w-full">
      <div>Please send this application link to your client.</div>
      <mat-form-field class="md:w-500px my-2">
        <input type="text"
          aria-label="Number"
          [(ngModel)]="applicationReferralUri"
          matInput
          readonly>
      </mat-form-field>
      <button mat-flat-button color="primary" class="sm:text-base w-full" [cdkCopyToClipboard]="copyToClipboard()">COPY TO CLIPBOARD</button>
    </div>
    <div class="sm:w-auto flex flex-col justify-center border-0 w-full">
      <div>
        Existing Referrals
      </div>
      <table mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="AddressLine1">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Address Line 1 </th>
          <td mat-cell *matCellDef="let element"> {{element.AddressLine1}} </td>
        </ng-container>

        <ng-container matColumnDef="City">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> City </th>
          <td mat-cell *matCellDef="let element"> {{element.City}} </td>
        </ng-container>

        <ng-container matColumnDef="State">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> State </th>
          <td mat-cell *matCellDef="let element"> {{element.State}} </td>
        </ng-container>

        <ng-container matColumnDef="Zip">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Zip </th>
          <td mat-cell *matCellDef="let element"> {{element.Zip}} </td>
        </ng-container>

        <ng-container matColumnDef="DateReferred">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Date Referred </th>
          <td mat-cell *matCellDef="let element"> {{element.DateReferred | date: 'MM/dd/YYYY'}} </td>
        </ng-container>

        <ng-container matColumnDef="Email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
          <td mat-cell *matCellDef="let element"> {{element.Email}} </td>
        </ng-container>

        <ng-container matColumnDef="ApplicationStatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Application Status </th>
          <td mat-cell *matCellDef="let element"> {{element.ApplicationStatus}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['AddressLine1', 'City', 'State', 'Zip', 'DateReferred', 'Email', 'ApplicationStatus']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['AddressLine1', 'City', 'State', 'Zip', 'DateReferred', 'Email', 'ApplicationStatus']"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="[10, 50, 100]"
                     showFirstLastButtons
                     aria-label="Select page">
      </mat-paginator>
    </div>
  </div>
</div>
